import {rootAPIUrl} from '__utils/constants'

// feth fund detail data
export const fundFetchURL= rootAPIUrl + "/accounting/fund_detail_report/";

// feth basic fund detail data
export const basicFundFetchURL= rootAPIUrl + "/accounting/basic_fund_detail_report/";